import React from "react";

// Components
import { Editor } from "@tinymce/tinymce-react";

// Hooks / Helpers
import { useRef } from "react";
import { ApiService } from "../../services";

// Types
import { RefObject } from "react";
import { Editor as TinyMCEEditor } from "tinymce";

export default function TinyMCE(props: any) {
  const editorRef: RefObject<TinyMCEEditor> = useRef(null);

  function handleFileUpload(blobInfo: any, fileType: "video" | "image" = "image") {
    const formData = new FormData();
    formData.append(fileType, blobInfo.blob(), blobInfo.filename());

    return ApiService.post(`news/${fileType}/upload`, formData, undefined, true)
      .then((response: any) => {
        return Promise.resolve(response.location);
      })
      .catch((error: Error) => {
        return Promise.reject("Error: " + error.message);
      });
  }

  function displayLoader() {
    const rootElement = document.getElementById("root");
    const divElement = document.createElement("div");
    const spinnerElement = document.createElement("ion-spinner");

    divElement.classList.add("tinymce-editor__loading");
    spinnerElement.setAttribute("name", "dots");
    divElement?.appendChild(spinnerElement);
    rootElement?.insertAdjacentElement("afterend", divElement);
  }

  function removeLoader() {
    const spinnerElement = document.querySelector(".tinymce-editor__loading");
    spinnerElement?.remove();
  }

  function handleVideoUpload(cb: any, value: any, meta: any) {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "video/*");

    input.onchange = function () {
      const file: File | undefined = (this as HTMLInputElement).files?.[0];
      const reader = new FileReader();

      reader.onload = async function () {
        const id = "blobid" + new Date().getTime();
        const editor = editorRef.current;
        const blobCache = editor && editor.editorUpload.blobCache;
        const readerResult = reader.result as string;
        const base64 = readerResult && readerResult.split(",")[1];
        const blobInfo = blobCache && blobCache.create(id, file as Blob, base64);

        displayLoader();

        const url = await handleFileUpload(blobInfo, "video").finally(removeLoader);
        cb(url, { title: file?.name });
      };
      reader.readAsDataURL(file as Blob);
    };
    input.click();
  }

  const config = {
    height: 612,
    resize: false,
    relative_urls: false,
    file_picker_types: "media",
    file_picker_callback: handleVideoUpload,
    images_upload_handler: handleFileUpload,
    menubar: "edit insert format table",
    plugins: [
      "advlist",
      "autolink",
      "lists",
      "link",
      "image",
      "charmap",
      "print",
      "preview",
      "anchor",
      "searchreplace",
      "visualblocks",
      "code",
      "fullscreen",
      "insertdatetime",
      "media",
      "table",
      "paste",
      "code",
      "help",
      "wordcount",
    ],
    toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
  };

  return (
    <div className="tinymce-editor">
      <Editor
        apiKey={process.env["REACT_APP_TINY_CLOUD_KEY"]}
        onInit={(evt, editor) => {
          // @ts-ignore
          editorRef.current = editor;
        }}
        // @ts-ignore
        init={config}
        value={props.value}
        onEditorChange={props.onIonChange}
      />
    </div>
  );
}
